import { BookMark } from '@assets/icons/bookMark';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ActionButtonsProps {
	onBack: () => void;
	onChat: () => void;
	onSendOffer: () => void;
	hasOffer?: boolean;
	requestType?: string;
	hideActions?: boolean;
	isPaid?: boolean;
	paymentStatus?: string;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
	onBack,
	onChat,
	onSendOffer,
	requestType,
	hasOffer,
	hideActions = false,
	isPaid = false,
	paymentStatus = '',
}) => {
	const { t } = useTranslation();

	if (hideActions) {
		return null;
	}

	return (
		<div className="flex gap-[20px] justify-end max-sm:justify-center flex-col md:flex-row">
			<Button
				variant="contained"
				onClick={onBack}
				sx={{
					padding: '10px 20px',
					fontWeight: '700',
					fontSize: '14px',
					color: '#7B809A',
					border: 'unset',
					backgroundColor: '#fff',
				}}
			>
				<ArrowBackOutlinedIcon className="mr-[10px] text-secondary" />
				<span className="text-dark">{t('back')}</span>
			</Button>
			<Button
				disabled
				variant="contained"
				sx={{
					padding: '10px 20px',
					fontWeight: '700',
					fontSize: '14px',
					color: '#7B809A',
					border: 'unset',
					boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
					'@media (max-width: 375px)': {
						padding: '10px',
					},
				}}
			>
				<BookMark />
				<span className="text-dark ml-[10px]">{t('fieldbook')}</span>
			</Button>
			{/* {requestType !== 'ONE_TIME' && requestType !== 'SEASONAL' && (
				<Button
					disabled
					variant="contained"
					sx={{
						padding: '10px 20px',
						fontWeight: '700',
						fontSize: '14px',
						color: '#7B809A',
						border: 'unset',
						boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.25)',
						'@media (max-width: 375px)': {
							padding: '10px',
						},
					}}
				>
					<span className="text-dark font-robot text-bold">F100</span>
				</Button>
			)} */}
			<Button
				variant="contained"
				onClick={onChat}
				sx={{
					padding: '10px 20px',
					fontWeight: '700',
					fontSize: '14px',
					color: '#7B809A',
					border: 'unset',
					backgroundColor: '#fff',
				}}
			>
				<QuestionAnswerOutlinedIcon className="mr-[10px] text-secondary" />
				<span className="text-dark">{t('chat')}</span>
			</Button>
			<Button
				type="submit"
				variant="contained"
				onClick={onSendOffer}
				disabled={isPaid}
				sx={{
					padding: '10px 20px',
					fontWeight: '700',
					fontSize: '14px',
					backgroundColor: isPaid ? '#00AB89' : hasOffer ? '#FFAA2B' : '#00AB89',
					'@media (max-width: 375px)': {
						padding: '10px',
					},
				}}
			>
				{isPaid 
					? paymentStatus === 'Accepted' ? t('accepted', 'Accepted') : t('paid')
					: hasOffer
						? requestType !== 'EXPRESS'
							? t('editOffer')
							: t('cancelOffer')
						: t('sendOffer')}
				{!isPaid && <KeyboardArrowRightIcon />}
			</Button>
		</div>
	);
};
